import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import UrlHandlerApiService from "@/core/services/url-handler.service";

const VendorRequestHistoryApiService = {
  URL: "",
  async init() {
    Vue.use(VueAxios, axios);
    this.URL = await UrlHandlerApiService.getBaseUrl();
  },

  /**
   * Get vendor request history records with filters
   * @param params - { status, vendorName, eventType, userEmail, errorCode, from, to, page, size }
   * @returns {*}
   */
  getRecords(params) {
    return Vue.axios.get(this.URL + `api/user/admin/vendor-request-history`, {
      params: { ...params, ignoreCountryId: true },
      ignoreCountryId: true
    });
  },

  /**
   * Get list of possible statuses
   * @returns {*}
   */
  getStatuses() {
    return Vue.axios.get(this.URL + `api/user/admin/vendor-request-history/statuses`, {
      ignoreCountryId: true
    });
  },

  /**
   * Get stats grouped by status and vendor
   * @param params - { from, to } optional date range
   * @returns {*}
   */
  getStats(params) {
    return Vue.axios.get(this.URL + `api/user/admin/vendor-request-history/stats`, {
      params: { ...params, ignoreCountryId: true },
      ignoreCountryId: true
    });
  },

  /**
   * Get all records for a given user
   * @param userId - user ID
   * @returns {*}
   */
  getRecordsByUserId(userId) {
    return Vue.axios.get(this.URL + `api/user/admin/vendor-request-history/user/${userId}`, {
      ignoreCountryId: true
    });
  },

  /**
   * Get all records linked to a given transaction
   * @param transactionHistoryId - transaction history ID
   * @returns {*}
   */
  getRecordsByTransactionId(transactionHistoryId) {
    return Vue.axios.get(
      this.URL + `api/user/admin/vendor-request-history/transaction/${transactionHistoryId}`,
      { ignoreCountryId: true }
    );
  },

  /**
   * Get pending records with retry count below maxRetries
   * @param maxRetries - exclude records at or above this retry count (default 5)
   * @returns {*}
   */
  getPendingRecords(maxRetries = 5) {
    return Vue.axios.get(this.URL + `api/user/admin/vendor-request-history/pending`, {
      params: { maxRetries, ignoreCountryId: true },
      ignoreCountryId: true
    });
  }
};

export default VendorRequestHistoryApiService;
